module.exports = __webpack_public_path__ + "media/images/icons/icon-close-088afcf992a222884b9e30b32244380a.svg";